module.exports = __webpack_public_path__ + "build/static/media/star_empty.dd0c00b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/star_empty.svg
// module id = 280
// module chunks = 6